import React from "react";
import { Link } from "react-router-dom";
import { Moon, Sun, Languages, Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Logo } from "./Logo";
import { useApp } from "../context/AppContext";

export function TopBar({ showAdminButton = true, right = null }) {
  const { theme, toggleTheme, lang, toggleLang, t } = useApp();
  return (
    <header className="sticky top-0 z-30 border-b border-border/70 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex h-[88px] max-w-6xl items-center justify-between gap-3 px-3 sm:h-24 sm:px-6">
        <Link
          to="/"
          className="flex items-center transition-opacity hover:opacity-85"
          data-testid="logo-link"
        >
          <Logo size={72} />
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleLang}
            aria-label={t("language")}
            data-testid="language-toggle"
            className="gap-1.5 text-xs uppercase tracking-wider"
          >
            <Languages className="h-4 w-4" />
            <span className="font-medium">{lang.toUpperCase()}</span>
          </Button>

          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            aria-label={t("theme_toggle")}
            data-testid="theme-toggle"
          >
            {theme === "dark" ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
          </Button>

          {showAdminButton && (
            <Button
              asChild
              variant="outline"
              size="sm"
              className="ml-1 gap-1.5 rounded-full border-primary/50 text-primary hover:bg-primary/10 hover:text-primary"
              data-testid="admin-nav-button"
            >
              <Link to="/admin">
                <Lock className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">{t("admin_link")}</span>
              </Link>
            </Button>
          )}

          {right}
        </div>
      </div>
    </header>
  );
}
